import type { BadgeVariant } from '../../components/ui/Badge';
import type { KhoaDich } from '../../i18n';
import type { LoiTenVaiTro } from './nghiep-vu/vai-tro';

/**
 * Nhãn module trong cột Quyền — nhóm biến thể **phân loại** của `Badge`.
 * Module là *loại*, không phải mức độ, và danh mục module đổi theo gói của tổ
 * chức nên không gán mỗi module một tông: một tông chung cho mọi module.
 */
export const TONG_MODULE: Extract<BadgeVariant, 'violet' | 'teal' | 'orange' | 'info'> = 'info';

/**
 * Vai trò chưa có quyền nào — nhóm biến thể **trạng thái**: `warning` vì đó
 * là việc quản trị còn dở (gán vai trò này cho ai cũng không mở được gì).
 */
export const TONG_CHUA_CO_QUYEN: Extract<BadgeVariant, 'warning'> = 'warning';

/** Số nhãn module hiện trong một ô trước khi gộp thành `+n`. */
export const SO_MODULE_HIEN = 3;

/** Cỡ trang khi nối hết danh sách vai trò: tổ chức có vài chục vai trò, một hai trang là hết. */
export const MOT_TRANG = 100;

/**
 * Nhãn của nhóm quyền nền tảng (`core`, ADR-0104). Quyền của module là dữ liệu bên nộp gói đặt nên không dịch;
 * nhóm này do nền tảng đặt nên đi theo ngôn ngữ giao diện. Mã lạ thì lùi về mô tả server trả.
 */
export const NHAN_NHOM_NEN_TANG: KhoaDich = 'vaiTroLop2.quyenNenTang.nhom';
export const NHAN_QUYEN_NEN_TANG: Readonly<Record<string, KhoaDich>> = {
  'core:module:read': 'vaiTroLop2.quyenNenTang.xem',
  'core:module:submit': 'vaiTroLop2.quyenNenTang.nop',
  'core:module:install': 'vaiTroLop2.quyenNenTang.cai',
};

export const KHOA_LOI_TEN: Record<LoiTenVaiTro, KhoaDich> = {
  trong: 'vaiTroLop2.fTenTrong',
  dai: 'vaiTroLop2.fQuaDai',
};
